/**
 * ATENEA — Comparador de productos (móvil primero).
 *
 * - <moldeamos-compare-toggle>: botón por tarjeta; selección en
 *   sessionStorage (sobrevive re-renders de facetas y navegación
 *   dentro de la sesión). Máximo 3.
 * - Barra flotante y hoja comparativa (<dialog>) se crean por JS
 *   una sola vez y viven en <body>.
 * Sin dependencias.
 */

(() => {
  const KEY = 'moldeamos-compare';
  const MAX = 3;
  const FIELDS = [
    ['price', 'Precio'],
    ['disponible', 'Disponibilidad'],
    ['dosis', 'Dosis recomendada'],
    ['rendimiento', 'Rendimiento'],
    ['compatible', 'Compatible con'],
    ['temperatura', 'Temperatura de uso'],
  ];

  const read = () => {
    try {
      return JSON.parse(sessionStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  };
  const write = (items) => {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(items));
    } catch {
      /* almacenamiento no disponible: la función sigue en memoria */
    }
    document.dispatchEvent(new CustomEvent('moldeamos:compare-change'));
  };

  /* ---------- Barra flotante + hoja ---------- */

  let bar, sheet;

  function ensureUI() {
    if (bar) return;

    bar = document.createElement('div');
    bar.className = 'moldeamos-compare-bar';
    bar.hidden = true;
    bar.innerHTML = `
      <button type="button" class="moldeamos-compare-bar__open" data-open>Comparar (<span data-count>0</span>)</button>
      <button type="button" class="moldeamos-compare-bar__clear" data-clear>Limpiar</button>
    `;
    document.body.appendChild(bar);

    sheet = document.createElement('dialog');
    sheet.className = 'moldeamos-compare-sheet';
    sheet.innerHTML = `
      <div class="moldeamos-compare-sheet__head">
        <h2>Comparar productos</h2>
        <button type="button" class="moldeamos-compare-sheet__close" data-close aria-label="Cerrar">&times;</button>
      </div>
      <div class="moldeamos-compare-sheet__body" data-body></div>
    `;
    document.body.appendChild(sheet);

    bar.querySelector('[data-open]').addEventListener('click', () => {
      renderSheet();
      sheet.showModal();
    });
    bar.querySelector('[data-clear]').addEventListener('click', () => write([]));
    sheet.querySelector('[data-close]').addEventListener('click', () => sheet.close());
    sheet.addEventListener('click', (e) => {
      if (e.target === sheet) sheet.close();
    });
  }

  function refreshBar() {
    ensureUI();
    const items = read();
    bar.hidden = items.length === 0;
    bar.querySelector('[data-count]').textContent = items.length;
    if (items.length === 0 && sheet.open) sheet.close();
  }

  function renderSheet() {
    const items = read();
    const body = sheet.querySelector('[data-body]');

    const cols = items
      .map(
        (p) => `
        <div class="moldeamos-compare-col">
          <button type="button" class="moldeamos-compare-col__remove" data-remove="${p.id}" aria-label="Quitar ${p.title}">&times;</button>
          <a href="${p.url}" class="moldeamos-compare-col__product">
            ${p.img ? `<img src="${p.img}" alt="" loading="lazy" width="150" height="150">` : ''}
            <span class="moldeamos-compare-col__title">${p.title}</span>
          </a>
          ${FIELDS.map(
            ([key, label]) => `
            <div class="moldeamos-compare-col__row">
              <span class="moldeamos-compare-col__label">${label}</span>
              <span class="moldeamos-compare-col__value">${p[key] || '—'}</span>
            </div>`
          ).join('')}
          <a href="${p.url}" class="moldeamos-compare-col__cta">Ver producto</a>
        </div>`
      )
      .join('');

    body.innerHTML = `<div class="moldeamos-compare-grid moldeamos-compare-grid--${items.length}">${cols}</div>`;

    body.querySelectorAll('[data-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        write(read().filter((p) => String(p.id) !== String(btn.dataset.remove)));
        if (read().length) renderSheet();
      });
    });
  }

  /* ---------- Toggle por tarjeta ---------- */

  if (!customElements.get('moldeamos-compare-toggle')) {
    customElements.define(
      'moldeamos-compare-toggle',
      class extends HTMLElement {
        connectedCallback() {
          this.btn = this.querySelector('button');
          if (!this.btn) return;
          this.id_ = this.btn.dataset.id;
          this.sync = this.sync.bind(this);
          this.btn.addEventListener('click', () => this.toggle());
          document.addEventListener('moldeamos:compare-change', this.sync);
          this.sync();
          refreshBar();
        }

        disconnectedCallback() {
          document.removeEventListener('moldeamos:compare-change', this.sync);
        }

        get selected() {
          return read().some((p) => String(p.id) === String(this.id_));
        }

        sync() {
          this.btn.setAttribute('aria-pressed', this.selected ? 'true' : 'false');
          refreshBar();
        }

        toggle() {
          let items = read();
          if (this.selected) {
            items = items.filter((p) => String(p.id) !== String(this.id_));
          } else {
            if (items.length >= MAX) {
              this.btn.animate(
                [{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }],
                { duration: 200 }
              );
              return;
            }
            const d = this.btn.dataset;
            items.push({
              id: d.id,
              title: d.title,
              url: d.url,
              img: d.img,
              price: d.price,
              disponible: d.disponible,
              dosis: d.dosis,
              rendimiento: d.rendimiento,
              compatible: d.compatible,
              temperatura: d.temperatura,
            });
          }
          write(items);
        }
      }
    );
  }

  document.addEventListener('moldeamos:compare-change', refreshBar);
  if (document.readyState !== 'loading') refreshBar();
  else document.addEventListener('DOMContentLoaded', refreshBar, { once: true });
})();
